<template>

    <!-- Header -->
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark-ed border-bottom hidden-md d-lg-none">
        <button class="btn btn-dark btn-sm bg-dark-ed custom-toggler" id="menu-toggle"
                @click="toggleNav()">
            <span class="navbar-toggler-icon "></span>
        </button>


        <div class="collapse navbar-collapse" id="navbarSupportedContent" v-bind:class="{ show: isMenuVisible }">
            <!-- MENU Page - top left -->
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0 ">


                <li class="nav-item">
                    <router-link to="/amortizations" class="list-group-item list-group-item-action bg-dark-ed">
                        Pratiche Cambiali
                    </router-link>

                </li>
                <li class="nav-item">

                    <router-link to="/search-promissory-notes"
                                 class="list-group-item list-group-item-action bg-dark-ed">Gestione Cambiali
                    </router-link>
                </li>
                <li class="nav-item">

                    <router-link to="/profile/settings" class="list-group-item list-group-item-action bg-dark-ed">
                        Profilo
                    </router-link>
                </li>

                <li class="nav-item">
                    <router-link to="/profile/margin-settings"
                                 class="list-group-item list-group-item-action bg-dark-ed">Impostazioni Stampa
                    </router-link>
                </li>
                <li class="nav-item">

                    <router-link to="/profile/plan" class="list-group-item list-group-item-action bg-dark-ed">
                        Abbonamento
                    </router-link>
                </li>
                <li class="nav-item">

                    <a @click="logout()" class="list-group-item list-group-item-action bg-dark-ed">Esci</a>
                </li>


            </ul>

        </div>

    </nav>


</template>

<script>
    // import NavMain from './NavMain.vue'
    import {store} from '../store/store'

    // import jQuery from "jquery";
    // const $ = jQuery;
    // window.$ = $;
    export default {
        name: 'HeaderComponent',
        store,
        data: function () {
            return {
                isMenuVisible: false
            }
        },
        methods: {
            toggleNav() {
                if (this.isMenuVisible) {
                    this.isMenuVisible = false
                } else {
                    this.isMenuVisible = true
                }
            }
        }
    }
</script>

<style scoped>
    .font-rounded {
        font-family: "Arial Rounded MT Bold";
        font-size: 30px;
    }

    /* .bg-dark-ed {
        background-color: #222939 !important;
    } */

    .my-bg {
        color: white !important;
    }


    .btn-dark {
        /* color: #fff; */
        /* background-color: #343a40; */
        background-color: transparent !important;

        border-color: #343a40;
        border-color: white !important;
    }

    .btn-dark:focus {
        background-color: red !important;
    }

    /* .btn.btn-primary {
      background-color: orange
    } */

    .btn.btn-dark:active,
    .btn.btn-dark:hover,
    .btn.btn-dark:focus {
        background-color: #3A9275 !important;
        border-color: #3A9275 !important;
    }

    /* .btn-dark {
        color: #fff;
        background-color: #343a40;
        border-color: #343a40;
    } */


    .bg-dark-ed span {
        /*overwriting*/
        /* color: white;
        font-size: 25px; */
    }

    .custom-toggler.navbar-toggler {
        border-color: rgb(255, 102, 203);
    }

    .custom-toggler .navbar-toggler-icon {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='white' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") !important;
    }

    #navbarSupportedContent {
        background: #222939;
        z-index: 9999;
    }
    .list-group-item{
        background: #222939 !important;
    }
</style>
